export { GooglePlaceModule } from './google-place.module';
export { GooglePlaceDirective } from './google-place.directive';
export { Address } from './objects/address';
